<template>
  <div>
    <h3>eDM</h3>
    <div class="h4 py-5">
      可編輯e-catalog 下方e-Catalog icon連結，未填連結者前台將導到英文版e-catalog連結
    </div>
    <div class="form-item d-flex h-64px align-center"
         v-for="item in navigation.edms_nav"
         :key="item.key">
      <label :for="`navitation-header-${item.key}`" class="mr-6">
        <h4 class="h4">{{ item.key }}</h4>
      </label>
      <div class="form-input-group flex-grow-1">
        <span class="prepend-icon"><v-icon>link</v-icon></span>
        <input
          type="text"
          :id="`navitation-header-${item.key}`"
          class="pl-42px"
          style="color: #194cc3"
          v-model="item.val"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    navigation: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style></style>
